import * as React from "react";

import './Button.scss';

export const Button = ({icon = false, type = 'button-primary', text = true, fill = 'white', link = null, reverse = false, label, onClick = null, disabled = false }) => {

  function _click(){
    if (onClick) {
      onClick();
    }
  }

  return (
      <>
        { !link && (
            <button type="submit" className={`${type}  ${reverse ? 'reverse' : ''}`} onClick={_click} disabled={disabled}>
              {icon && (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill={fill} fillRule="evenodd">
                    <path fill={fill} d="M8.38982 14.17C10.4063 13.9223 12.3211 14.6275 13.6804 15.9311C13.0258 13.7977 10.9199 12.3737 8.62697 12.6553C6.75007 12.8854 5.2743 14.1957 4.73359 15.8837C5.70388 14.97 6.96419 14.3446 8.38982 14.17Z"/>
                    <path fill={fill} d="M15.1141 6.35005C16.556 7.77272 17.4491 9.74633 17.4491 11.9297C17.4491 14.1132 16.5547 16.0881 15.1141 17.5094C17.4857 16.7609 19.2054 14.5463 19.2054 11.9297C19.2054 9.31316 17.4857 7.09861 15.1141 6.35005Z"/>
                    <path fill={fill} d="M9.80326 7.53988C12.3076 7.27728 14.5924 8.76357 15.438 11.0147C15.5112 10.6411 15.5315 10.2499 15.4895 9.85054C15.2632 7.70502 13.3389 6.14834 11.1909 6.3744C10.1041 6.4881 9.16904 7.03768 8.53889 7.82956C8.93866 7.68607 9.36147 7.5859 9.80326 7.53988Z"/>
                    <path fill={fill} d="M8.86952 10.5991C11.752 10.5991 14.2333 12.3074 15.3594 14.7656C15.2889 11.5954 12.6965 9.04513 9.5051 9.04513C7.20945 9.04513 5.22414 10.3649 4.26333 12.2844C5.50737 11.234 7.11459 10.5991 8.86952 10.5991Z"/>
                    <path fill={fill} clipRule="evenodd" d="M12 22.7616C17.9418 22.7616 22.7586 17.9448 22.7586 12.0029C22.7586 6.06111 17.9418 1.24431 12 1.24431C6.05818 1.24431 1.24138 6.06111 1.24138 12.0029C1.24138 17.9448 6.05818 22.7616 12 22.7616ZM12 24.0029C18.6274 24.0029 24 18.6303 24 12.0029C24 5.37551 18.6274 0.00292969 12 0.00292969C5.37258 0.00292969 0 5.37551 0 12.0029C0 18.6303 5.37258 24.0029 12 24.0029Z"/>
                  </svg>
              )}
              {text && label}
            </button>
        )}

        { link && (
            // @ts-ignore
            <a href={link}>
              <button className={`${type} button button-link ${reverse ? 'reverse' : ''}`}>
                {text && label}
              </button>
            </a>
        )}
      </>
  );
};